document.addEventListener("DOMContentLoaded", function() {
      var target = document.querySelector('body');
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if(mutation.type == 'childList' && document.querySelector('.smart-tabs-navigation-wrapper')){
            observer.disconnect();
            $('.smart-tabs-accordion-symbol.smart-tabs-accordion-plus').each(function(){
              $(this).empty();
              $(this).addClass('vis')
              $(this).append('<svg t="1627953180527" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1888" width="100%" height="100%"><path d="M511.999488 634.683157 132.797004 255.480672l-66.916039 66.916039 446.1175 446.122617 446.1175-446.122617-66.916039-66.916039L511.999488 634.683157zM511.999488 634.683157" p-id="1889"></path></svg>')
            });
            $('.smart-tabs-accordion-symbol.smart-tabs-accordion-minus').each(function(){
              $(this).empty();
              $(this).addClass('vis')
              $(this).append('<svg class="ymq_tab_icon_transform" t="1627953180527" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1888" width="100%" height="100%"><path d="M511.999488 634.683157 132.797004 255.480672l-66.916039 66.916039 446.1175 446.122617 446.1175-446.122617-66.916039-66.916039L511.999488 634.683157zM511.999488 634.683157" p-id="1889"></path></svg>')
            });
          }
        });    
      });
      var config = { attributes: true, childList: true, characterData: true };
      observer.observe(target,  config);
});